<template>
    <div>
        <Section title="填写推荐信息">
            <Form :model="formItem" :label-width="120" style=" padding: 30px">
                <FormItem label="推荐名称">
                    <Input v-model="formItem.input" style="width: 400px" placeholder="上线5个汉字，超出即隐藏"></Input>
                </FormItem>

                <FormItem label="自定义图标">
                    <UploadBox>
                        <span slot="upload">+ 添加图片</span>
                        <span class="colorA3 fs-12px">推荐 100*100px，上限20K，仅支持jpg/png</span>
                    </UploadBox>
                </FormItem>

                <FormItem label="系统推荐图标">
                    <Scroll style="min-height: 100px; max-height: 200px; padding: 10px">
                        <ul>
                            <li style="width: 50px; height: 50px; background-color: #CCCCCC; float: left; margin-right: 10px; margin-bottom: 10px;" v-for="i in 50"></li>
                        </ul>
                    </Scroll>
                </FormItem>
            </Form>

            <div style="text-align: center; padding: 30px 0; border-top: 1px solid #e3e8ee">
                <Button class="mr-20px" style="width: 100px">取消</Button>
                <Button type="primary" style="width: 100px">下一步</Button>
            </div>

        </Section>

    </div>
</template>

<script>

    import UploadBox from '@/modules/UploadBox'
    import Scroll from '@/modules/Scroll'

    import { Input, Select, Option, Button, Form, FormItem, Upload } from 'iview';

    export default {
        name: "Form1",
        data () {
            return {
                formItem: {
                    input: '',
                    select: '',
                    radio: 'male',
                    checkbox: [],
                    switch: true,
                    date: '',
                    time: '',
                    slider: [20, 50],
                    textarea: ''
                }
            }
        },

        components: {
            UploadBox,
            Input,
            Select,
            Option,
            Button,
            Form,
            FormItem,
            Upload,
            Scroll
        }
    }
</script>

<style lang="less">
    @import "../../../../styles/comm.less";
</style>
